export default __webpack_public_path__ + "static/media/thumbnail2.3acf6620.jpg";